import React, { Fragment } from 'react';
import { get } from 'lodash-es';
import { Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RealizedPricesTableColumns = (
  handleModal,
  editLot,
  handleCheckbox,
  handleCheckboxAll,
  selectedLots,
  spreadsheetErrors
) => {
  // The following items will be in both live and timed sales
  const tableColumns = [
    {
      Header: () => (
        <Fragment>
          {selectedLots.size > 0 ? (
            <FontAwesomeIcon
              className="color-blue cursor-pointer"
              icon="minus-square"
              onClick={() => handleCheckboxAll()}
            />
          ) : (
            <Input
              className="ml-0 position-relative"
              checked={false}
              onChange={() => handleCheckboxAll()}
              type="checkbox"
            />
          )}
        </Fragment>
      ),
      headerClassName: 'd-flex justify-content-center align-items-center',
      id: 'selectIcon',
      fixed: 'left',
      width: 55,
      sortable: false,
      accessor: d => ({
        id: d.id
      }),
      Cell: ({ value: { id } }) => (
        <div className="text-center">
          <Input
            className="ml-0 position-relative"
            checked={selectedLots.has(id)}
            onChange={() => handleCheckbox(id)}
            type="checkbox"
          />
        </div>
      )
    },
    {
      Header: 'Actions',
      id: 'actions',
      fixed: 'left',
      width: 70,
      sortable: false,
      accessor: d => ({
        id: d.id
      }),
      Cell: ({ value: { id } }) => (
        <div className="px-2 text-center">
          <FontAwesomeIcon
            className="color-blue cursor-pointer"
            icon="edit"
            onClick={() => editLot(id)}
          />
        </div>
      )
    },
    {
      Header: 'Item #*',
      id: 'lotNumber',
      width: 400,
      getProps: (state, rowInfo) => {
        const hasError = get(rowInfo, 'original.hasError');
        if (!hasError) {
          return { className: '' };
        }

        const lotNum = get(rowInfo, 'original.lotNumber');
        const lotId = lotNum + get(rowInfo, 'original.lotExt');
        const lotError = !lotNum
          || get(spreadsheetErrors, '[108].lotNumbers', new Set()).has(lotId)
          || get(spreadsheetErrors, '[109].lotNumbers', new Set()).has(lotId)
          || get(spreadsheetErrors, '[110].lotNumbers', new Set()).has(lotId)
          || get(spreadsheetErrors, '[149].lotNumbers', new Set()).has(lotId)
          || get(spreadsheetErrors, '[112].lotNumbers', new Set()).has(lotId);
        return {
          className: lotError ? 'no-image-border' : ''
        };
      },
      accessor: d => ({
        lotNumber: d.lotNumber
      }),
      Cell: ({ value: { lotNumber } }) => <p>{lotNumber}</p>
    },
    {
      Header: 'Lot Ext.',
      id: 'lotExt',
      width: 183,
      sortable: false,
      accessor: d => ({
        lotExt: d.lotExt
      }),
      Cell: ({ value: { lotExt } }) => <p>{lotExt}</p>
    },
    {
      Header: 'Realized Price',
      id: 'realizedPrice',
      width: 400,
      getProps: (state, rowInfo) => {
        const hasError = get(rowInfo, 'original.hasError');
        if (!hasError) {
          return { className: '' };
        }

        const lotId = get(rowInfo, 'original.lotNumber');
        const lotError = get(spreadsheetErrors, '[142-Illegal number format].lotNumbers', new Set()).has(lotId)
        || get(spreadsheetErrors, '[179].lotNumbers', new Set()).has(lotId);
        return {
          className: lotError ? 'no-image-border' : ''
        };
      },
      accessor: d => ({
        realizedPrice: d.realizedPrice
      }),
      Cell: ({ value: { realizedPrice } }) => <p>{realizedPrice}</p>
    }
  ];

  return tableColumns;
};

export default RealizedPricesTableColumns;
